<template>
  <div :class="music.disabled ? 'disabled-player' : ''">
    <file-player-row :music="music" :is_hidden_name="hide_name" :is_file_converted="converted">
      <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
        <slot :name="slot" v-bind="scope"></slot>
      </template>
    </file-player-row>
  </div>
</template>

<script>
  import { getMediaPredictiveFilePath } from '@shared/helpers/url';
  import FilePlayerRow from '@shared/components/z-player-row';
  import { mapGetters } from 'vuex';

  export default {
    components: {
      FilePlayerRow
    },

    props: {
      file: {
        type: Object,
        default: () => ({})
      },
      hide_name: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters('core/auth', ['user']),

      music() {
        return {
          disabled: this.file.state !== 'finished',
          title: this.getName(this.file),
          src: getMediaPredictiveFilePath(this.user.id, this.file.storage_file)
        };
      },
      converted() {
        return !!this.file.file_sln;
      }
    },
    methods: {
      getName(file) {
        if (file.state === 'finished') {
          return file.description;
        } else if (file.state === 'pending' || file.state === 'processing') {
          return `${file.description} - ${this.$t('shared.component.file_upload.file_processing')}`;
        } else {
          return this.$t('shared.component.file_upload.file_fail');
        }
      }
    }
  };
</script>

<style lang="scss">
  .disabled-player {
    & *,
    .aplayer-bar-wrap {
      opacity: 0.9;
      cursor: not-allowed;
    }
  }
</style>
